import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { QuitDuelOutput, WebAppRoutes } from "types/web-app";

export const quitDuel = async (
  token: string,
  duelId: string,
): Promise<ServiceResponse<QuitDuelOutput>> => {
  const response = await fetchWithAuth(`/${WebAppRoutes.QUIT_DUEL}`, token, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ duel_id: duelId }),
  });

  return response.json();
};
